/* eslint-disable react/jsx-props-no-spreading */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { provide } from 'next/components/Hacks';
import { selectUser, Shape as UserShape } from 'next/entities/user';
import { BeaconTrigger } from './styled';

const BeaconLink = ({
  children,
  light = false,
  mailto = 'sales@appcues.com',
  message,
  subject,
  user,
  ...unhandledProps
}) => {
  const { email, fullname: name } = user ?? {};
  const text = ['Hi,', message, 'Thanks!'].join('\n\n');

  // Handle potential upsell request. If the Helpscout beacon exists on the
  // page, use that to contact the sales team. However if the beacon fails or
  // does not exist on the page, fallback to using a mailto link
  const handleClick = event => {
    if (window.Beacon) {
      try {
        /* eslint-disable new-cap */
        window.Beacon('prefill', {
          name,
          email,
          subject,
          text,
        });
        window.Beacon('navigate', '/ask/');
        window.Beacon('open');
        /* eslint-enable new-cap */

        event.preventDefault();
      } catch {
        // TODO: report error?
      }
    }
  };

  return (
    <BeaconTrigger
      href={`mailto:${mailto}?subject=${encodeURIComponent(
        subject
      )}&body=${encodeURIComponent(message)}`}
      icon={false}
      onClick={handleClick}
      $light={light}
      {...unhandledProps}
    >
      {children}
    </BeaconTrigger>
  );
};

BeaconLink.propTypes = {
  children: PropTypes.node,
  // Whether or not light colors should be used. Used within tooltips
  light: PropTypes.bool,
  // Fallback email in case helpscout beacon does not load
  mailto: PropTypes.string,
  // The beacon message
  message: PropTypes.string,
  // The beacon subject
  subject: PropTypes.string,
  // User entity
  user: UserShape,
};

const mapStateToProps = state => ({
  user: selectUser(state),
});

const Connected = provide(mapStateToProps)(BeaconLink);

export default styled(Connected)``;
